module.exports = __webpack_public_path__ + "img/FL-pin.8a6ab7a4.png";